import Vue from "vue";

export default {
    getRegistrosPatronales(parametros){
        return Vue.axios.get("registro-patronal/find", {params: parametros}).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
    getRegistroPatronal(id){
        return Vue.axios.get("registro-patronal/" + id).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
}